const setSubscriptionsDetail = (state, payload) => {
  state.subscriptionsDetail = payload;
};

export default { setSubscriptionsDetail };
